/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import { Link } from "react-router-dom";
// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function ElectoralDistrictMapInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Nova Scotia Electoral District Maps"
              description={
                <>
                  {/* <h4>In the fall of 2019, House of Assembly legislated 55 electoral district boundaries as recommended by the Electoral Boundaries Commission. These 55 new district boundaries came into force for the 41st provincial general election, which was held on August 17, 2021.</h4>
                   */}
                  <br />
                  <h3>Electoral District Information</h3>
                  <ul style={{ paddingLeft: "40px" }}>
                    <br /><li>Electoral District Finder - follow this link and enter your home address to find your <a href="https://enstools.electionsnovascotia.ca/edinfo/">electoral district </a>in the 56 electoral districts</li>
                    <br /><li>2026 Provincial Electoral Districts of Nova Scotia (<a href="/files/ElectoralDistrictMapInformation/ED2026ofNS.pdf">PDF Map)</a></li>
                    <br /><li>Provincial General Election Results Map - 2024 (<a href="/files/ElectoralDistrictMapInformation/2024ResultsMap.pdf">PDF Map)</a></li>

                    <br /><li>Distribution of Seats by Political Party Map, 2026 (<a href="/files/ElectoralDistrictMapInformation/DistributionOfSeatsByParty_2026_06.pdf">PDF Map)</a></li>
                    <br /><li><a href="https://enstools.electionsnovascotia.ca/mapguidebook">Online Map Guide Book and Street Key Tool</a></li>
                    <br /><li>Provincial Electoral District data files (<a href="/files/ElectoralDistrictMapInformation/NS_2026ED_Bnds.zip">Shapefile</a>, <a href="/files/ElectoralDistrictMapInformation/NS2026_ED_Bnds.kmz">KMZ Google Earth Format</a>)</li>
                    <br /><li>Provincial Polling Divisions data files (<a href="/files/ElectoralDistrictMapInformation/ProvincialPollingDivisionPolygons_March_2026.zip">Shapefile,</a> <a href="/files/ElectoralDistrictMapInformation/ProvincialPollingDivisionPolygons_March_2026.kmz">KMZ</a>)</li>
                  <br />
                  <li>
                     You can order maps using our{" "}
                      <Link to="/MapOrderForm" color="primary">
                        Map Order Form
                      </Link>
                      .
                    </li>
                  </ul>
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ElectoralDistrictMapInformation;
